import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store from './store'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import '@/style/index.css';
import '@/style/media.css';

import '@/utils/editor.js' //富文本   // 注意：需要图片调节大小 vue.config.js同步添加quill模块

import './permission' //路由权限
//大分类
Vue.prototype.majorIdForAll = window.config.VUE_MAJORID;
//附件公共地址
if(window.config.VUE_IS_LOCAL) {
	Vue.prototype.baseurl = window.config.VUE_FILE_BASE_PATH;
} else {
	Vue.prototype.baseurl = window.config.VUE_FILE_OSS_PATH;
}
Vue.prototype.effective = window.config.VUE_IS_EFFECTIVE;

import * as filters from './filters' // global filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

import emptymain from '@/components/emptymain'
Vue.component('emptymain', emptymain)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
